import { createContext, type ReactNode, useContext } from 'react'

export type CheckboxMenuContextType<
  Data extends Record<string, unknown> = Record<string, unknown>
> = {
  rows: Data[]
  closeMenu: () => void
  deselectAll: () => void
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CheckboxMenuContext = createContext<CheckboxMenuContextType<any> | undefined>(undefined)

export const useCheckboxMenuContext = <
  Data extends Record<string, unknown>
>(): CheckboxMenuContextType<Data> => {
  const context = useContext(CheckboxMenuContext)
  if (context === undefined) {
    throw new Error('useCheckboxMenuContext must be used within a CheckboxMenuContextProvider')
  }
  return context
}

type CheckboxMenuContextProviderProps<Data extends Record<string, unknown>> = {
  children: ReactNode
  value: CheckboxMenuContextType<Data>
}

export const CheckboxMenuContextProvider = <Data extends Record<string, unknown>>({
  children,
  value
}: CheckboxMenuContextProviderProps<Data>) => {
  return <CheckboxMenuContext.Provider value={value}>{children}</CheckboxMenuContext.Provider>
}
